import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import InputMoney from "components/Input/InputMoney/index";

export interface InputCalcularProps {
  onChange: (v?: number) => void;
  maxW?: number | string;
  value: number;
  valorCalculado?: number;
}

function InputCalcular({
  onChange,
  value,
  valorCalculado = 0,
  maxW = 350,
}: InputCalcularProps) {
  return (
    <>
      <Box maxW={maxW} w="100%" d="flex" flexDir="row" pos="relative">
        <InputMoney
          value={value}
          onChange={onChange}
          style={{
            textAlign: "left",
            paddingRight: "88px",
          }}
        />
        <Button
          right="4px"
          w="72px"
          size="sm"
          top="4px"
          pos="absolute"
          zIndex="1"
          mr="2px"
          rounded={8}
          bg={colors.primary}
          _hover={{
            bg: colors.primaryDark,
          }}
          _active={{
            bg: colors.primaryDark,
          }}
          color="white"
          onClick={() => onChange(valorCalculado)}
        >
          Calcular
        </Button>
      </Box>
    </>
  );
}

export default InputCalcular;
